// ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { clearQuotationCache } from "../utils/quotationCache";
import { clearTimesheetCache } from "../utils/timesheetCache";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    // 👉 ถ้าไม่มี token เก็บ path ปัจจุบันไว้ใน state แล้วส่งไปหน้า login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000; // วินาที

    if (decodedToken.exp < currentTime) {
      // 🔥 Token หมดอายุ: เคลียร์ localStorage และ Redirect ไปหน้า Login
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("teams");
      localStorage.removeItem("departments");
      localStorage.removeItem("timesheetClients");
      clearQuotationCache();
      clearTimesheetCache();
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  } catch (error) {
    console.error("Invalid token:", error);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("teams");
    localStorage.removeItem("departments");
    localStorage.removeItem("timesheetClients");
    clearQuotationCache();
    clearTimesheetCache();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
